import { Card, Flex, Typography } from "@payping/web-components";

import useTranslator from "@/shared/translate/translator";
import RefundTransactions from "@/refund/views/refund-transactions";
import Deposit from "@/refund/components/deposit";
import { Balance } from "@/refund/components";

const Wallet: React.FC = () => {
  const { t } = useTranslator("refund.wallet");

  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      gap="32px"
      className="tw-w-full tw-pe-[58px] tw-ps-[28px] tw-pt-[24px]"
    >
      <Typography.Title level={4} className="!tw-m-0">
        {t("title")}
      </Typography.Title>
      <Card.Ant className="tw-w-full">
        <Flex justify="center" align="center" vertical gap="13px">
          <Balance />
          <Flex align="center" gap="middle">
            <Deposit />
            {/* <Link to={"/refund/wallet"}>
              <Button type="link">{t("report")}</Button>
            </Link> */}
          </Flex>
        </Flex>
      </Card.Ant>
      <RefundTransactions />
    </Flex>
  );
};
export default Wallet;
